/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `tax_form` - tax_form
 * * `authorization` - authorization
 * * `identity_verification` - identity_verification
 * * `payroll_output` - payroll_output
 * * `agency_notice` - agency_notice
 * * `other` - other
 */
export type PayrollDocumentKindEnum = (typeof PayrollDocumentKindEnum)[keyof typeof PayrollDocumentKindEnum];

export const PayrollDocumentKindEnum = {
    tax_form: 'tax_form',
    authorization: 'authorization',
    identity_verification: 'identity_verification',
    payroll_output: 'payroll_output',
    agency_notice: 'agency_notice',
    other: 'other',
} as const;
